export default {"src":"/_next/static/media/baby7.52825e13.svg","height":210,"width":210,"blurWidth":0,"blurHeight":0};